import moment from "moment";
import React, { useState, useEffect, forwardRef, useRef } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { useLocation } from "react-router";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Button } from "../../../components/common/Button/Button";
import { mainAxiosInstance } from "../../../services/service";
import { maintenanceLogEndPoints } from "../../../services/service-constants";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";

const MaintenanceLogsSummary = () => {
  const navigate = useNavigate();
  const urlPathObj = useLocation();
  const [noDataFound, setNoDataFound] = useState(true);
  const [scoreDetails, setScoreDetails] = useState({});
  const [detailsClicked, setDetailsClicked] = useState(false);
  const vin_Number = useSelector((state) => state.mainReducer.vin_Number);

  const getScoreCard = (payload) => {
    const url = `${maintenanceLogEndPoints.score_card}`;
    const { vinNumber } = payload;
    const params = {
      vin_number: vinNumber,
      organization_id: 1,
    };

    mainAxiosInstance
      .get(url, { params: params })
      .then((response) => {
        setNoDataFound(false);
        setScoreDetails(response.data);
      })
      .catch((er) => {
        setNoDataFound(true);
        throw er;
      });
  };

  useEffect(() => {
    getScoreCard({
      vinNumber: vin_Number,
    });

    if (urlPathObj.pathname.includes("/maintenance-log/summary/")) {
      setDetailsClicked(true);
    } else {
      setDetailsClicked(false);
    }
  }, [urlPathObj.pathname]);

  const handleDetailsClick = () => {
    setDetailsClicked(true);
    navigate("/maintenance-log/summary/time-driven-action", {
      replace: true,
    });
  };
  return (
    <>
      {!noDataFound ? (
        <>
          <div className="page-wrapper maintenance-log-summary-wrapper">
            <div className="maintenance-score-container">
              <div className="score-graph-container">
                <div className="score-graph">
                  <CircularProgressbar
                    value={scoreDetails.score}
                    text={`${scoreDetails.score}%`}
                    counterClockwise={true}
                    strokeWidth="15"
                    styles={buildStyles({
                      pathColor: "#A9D18E",
                      textColor: "#A9D18E",
                    })}
                  />
                </div>
                <div className="score-details-button">
                  <Button
                    title="View details"
                    handleClick={() => handleDetailsClick()}
                    styleClasses={`btn ${
                      detailsClicked ? "btn-disabled" : "btn-primary"
                    }`}
                  />
                </div>
              </div>

              <div className="score-details-container">
                <div className="score-text">Maintenance score</div>
                <ul className="score-details-ul">
                  <li className="score-details-li">
                    <div className="score-param">VIN</div>
                    <div className="score-seperator">:</div>
                    <div className="score-value">{scoreDetails.vinNumber}</div>
                  </li>
                  <li className="score-details-li">
                    <div className="score-param">Last Update Date</div>
                    <div className="score-seperator">:</div>
                    <div className="score-value">
                      {moment(scoreDetails.lastUpdated).format("DD/MM/YYYY")}
                    </div>
                  </li>
                  <li className="score-details-li">
                    <div className="score-param">Odometer Reading</div>
                    <div className="score-seperator">:</div>
                    <div className="score-value">{scoreDetails.odometer}</div>
                  </li>
                  <li className="score-details-li">
                    <div className="score-param">Maintenance Status</div>
                    <div className="score-seperator">:</div>
                    <div className="score-value">
                      {scoreDetails.maintenanceStatus}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {detailsClicked && (
              <div className="tabs-container">
                <NavLink
                  to="/maintenance-log/summary/time-driven-action"
                  className={({ isActive }) =>
                    isActive ? "btn-primary tabs" : "btn-secondary tabs"
                  }
                >
                  Time Driven Actions
                </NavLink>
                <NavLink
                  to="/maintenance-log/summary/maintenance-on-demand"
                  className={({ isActive }) =>
                    isActive ? "btn-primary tabs" : "btn-secondary tabs"
                  }
                >
                  Maintenance on-Demand
                </NavLink>
                <NavLink
                  to="/maintenance-log/summary/quality"
                  className={({ isActive }) =>
                    isActive ? "btn-primary tabs" : "btn-secondary tabs"
                  }
                >
                  Quality
                </NavLink>
                <NavLink
                  to="/maintenance-log/summary/location"
                  className={({ isActive }) =>
                    isActive ? "btn-primary tabs" : "btn-secondary tabs"
                  }
                >
                  Locations
                </NavLink>
              </div>
            )}
            <Outlet />
          </div>
        </>
      ) : (
        <>
          <div className="padding-30">No Data Found</div>
        </>
      )}
    </>
  );
};

export default MaintenanceLogsSummary;
